import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MaterialModule } from './material/material.module';
import { HttpClientModule, HttpClient } from '@angular/common/http';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';

import { AppRoutingModule } from './app-routing/app-routing.module';
import { AuthGuard } from './auth.guard';
import { CanDeactivateGuard } from './can-deactivate.guard';
import { ServerDataService } from './server-data.service';
import { WebsocketService } from './websocket.service';
import { DialogsService } from './dialogs.service';
import { DataStorageService } from './data-storage.service';
import { FeedbackStarsService } from './feedback-stars.service';
import { AuthenticationService } from './_services/authentication.service';
import { UserService } from './_services/user.service';


import { AppComponent } from './app.component';
import { PageNotFoundComponent } from './page-not-found/page-not-found.component';
import { DialogConfirmComponent } from './dialog-confirm/dialog-confirm.component';
import { DialogShowComponent } from './dialog-show/dialog-show.component';
import { DialogSelectSideComponent } from './dialog-select-side/dialog-select-side.component';
import {MatSnackBarModule} from "@angular/material";

import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { AuthInterceptor } from './_services/authinterceptor';
import { SellerService } from './admin-sellers/admin-seller-service.service';



export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}



@NgModule({
  declarations: [
    AppComponent,
    PageNotFoundComponent,
    DialogConfirmComponent,
    DialogShowComponent,
    DialogSelectSideComponent,
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    FlexLayoutModule,
    MaterialModule,
    HttpClientModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    }),
  ],
  providers: [
    SellerService,
    ServerDataService,
    AuthenticationService,
    UserService,
    AuthGuard,
    CanDeactivateGuard,
    WebsocketService,
    DialogsService,
    DataStorageService,
  ],
  entryComponents: [
    DialogConfirmComponent,
    DialogShowComponent,
    DialogSelectSideComponent
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts